export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          关于我们
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-full md:w-1/3">
              <div className="aspect-square max-w-[240px] mx-auto rounded-2xl overflow-hidden bg-secondary-100">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylized%20brand%20illustration%20of%20a%20modern%20media%20portal%20with%20abstract%20geometric%20shapes%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20minimalist%20editorial%20design%2C%20clean%20composition%20representing%20news%20aggregation%20and%20entertainment%20content%2C%20professional%20yet%20friendly%20brand%20identity&width=480&height=480&seq=about-brand&orientation=squarish"
                  alt="吃瓜入口品牌形象"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="font-heading text-xl text-foreground-950 mb-4">吃瓜入口 — 你的每日大赛吃瓜第一站</h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                吃瓜入口成立于2024年，是一个专注于每日大赛资讯聚合与深度解读的内容平台。我们追踪选秀综艺、电竞赛事、音乐比赛、舞蹈竞技等各类热门大赛，每日更新最新视频、独家爆料与系列追踪内容。
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                我们的编辑团队由资深娱乐记者、电竞分析师和短视频创作者组成，坚持内容核实与多元视角，致力于为吃瓜群众提供最全、最快、最可靠的大赛吃瓜在线体验。
              </p>
              <p className="text-sm text-foreground-500 leading-relaxed">
                吃瓜入口每日更新，大赛吃瓜在线直达 — 不再错过任何一期精彩大赛爆料，从这里开始你的吃瓜之旅。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}